import { Component, Input } from '@angular/core';
import { AppService } from '../../services/app.service';
import { Beneficio, beneficiosDeNivel } from '../../shared/beneficios';

@Component({
  selector: 'app-beneficios-resumen',
  templateUrl: './beneficios-resumen.component.html',
  styleUrls: ['./beneficios-resumen.component.scss']
})
export class BeneficiosResumenComponent {

  /** Nombre del nivel, para el titulo y para elegir la lista. */
  @Input() nivel? : string | null;

  constructor(private appService : AppService) {}

  /**
   * Beneficios reales del Club, por pais y nivel. Ver shared/beneficios.ts.
   * El resumen de la home muestra solo los primeros; la lista completa esta en
   * la pantalla Mis beneficios.
   */
  get beneficios() : Beneficio[] {
    return beneficiosDeNivel(this.appService.countryCode, this.nivel).slice(0, 3);
  }

  get hayBeneficios() : boolean {
    return this.beneficios.length > 0;
  }
}
